import "core-js/modules/es.symbol";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.map";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.get-own-property-descriptors";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.starts-with";
import "core-js/modules/web.dom-collections.for-each";
import _defineProperty from "/Users/suifeng/Desktop/projects/2026/QianKunLong/QklAdmin/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { storeList, storeReview, storeHandle, storeDelete } from '@/api/apis';
import upload from '@/plugin/upload';
import tableExcelSelect from '@/components/rw/tempTable/components/tableExcelSelect';
export default {
  name: 'storeManager',
  components: {
    tableExcelSelect: tableExcelSelect
  },
  data: function data() {
    return {
      loading: false,
      searchNumber: '',
      searchLicenseName: '',
      searchShopNo: '',
      searchStatus: '',
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      // 审核弹窗
      reviewDialogVisible: false,
      reviewLoading: false,
      currentRow: {},
      reviewForm: {
        status: 1,
        remark: ''
      },
      reviewRules: {
        status: [{
          required: true,
          message: '请选择审核结果',
          trigger: 'change'
        }]
      },
      // 编辑弹窗
      editDialogVisible: false,
      editLoading: false,
      editForm: {
        id: '',
        number: '',
        license_name: '',
        license_legal_person: '',
        license_credit_code: '',
        license_company_type: '',
        license_registered_capital: '',
        license_valid_period: '',
        license_business_address: '',
        license_img: ''
      },
      editRules: {
        license_name: [{
          required: true,
          message: '请输入执照名称',
          trigger: 'blur'
        }],
        number: [{
          required: true,
          message: '请输入会员编号',
          trigger: 'blur'
        }]
      },
      // 店铺编号弹窗
      numberDialogVisible: false,
      // 营业执照预览
      licenseDialogVisible: false,
      licensePreviewUrl: '',
      // 导出字段
      exportModel: [{
        show: 1,
        label: '会员编号',
        prop: 'number'
      }, {
        show: 1,
        label: '店铺编号',
        prop: 'shop_no'
      }, {
        show: 1,
        label: '执照名称',
        prop: 'license_name'
      }, {
        show: 1,
        label: '法人姓名',
        prop: 'license_legal_person'
      }, {
        show: 1,
        label: '统一社会信用代码',
        prop: 'license_credit_code'
      }, {
        show: 1,
        label: '公司类型',
        prop: 'license_company_type'
      }, {
        show: 1,
        label: '注册资金',
        prop: 'license_registered_capital'
      }, {
        show: 1,
        label: '执照有效期',
        prop: 'license_valid_period'
      }, {
        show: 1,
        label: '注册地址',
        prop: 'license_business_address'
      }, {
        show: 1,
        label: '审核状态',
        prop: 'status'
      }, {
        show: 1,
        label: '申请时间',
        prop: 'add_time'
      }, {
        show: 1,
        label: '审核时间',
        prop: 'audit_time'
      }, {
        show: 1,
        label: '审核意见',
        prop: 'remark'
      }]
    };
  },
  computed: {
    pagedData: function pagedData() {
      return this.tableData;
    }
  },
  mounted: function mounted() {
    this.loadData();
  },
  methods: {
    // 加载店铺申请列表
    loadData: function loadData() {
      var _this = this;

      this.loading = true;
      var params = {
        page: this.currentPage,
        limit: this.pageSize
      };
      var where = {};

      if (this.searchNumber) {
        where.number = this.searchNumber;
      }

      if (this.searchLicenseName) {
        where.license_name = this.searchLicenseName;
      }

      if (this.searchShopNo) {
        where.shop_no = this.searchShopNo;
      }

      if (this.searchStatus !== '' && this.searchStatus !== null) {
        where.status = this.searchStatus;
      }

      if (Object.keys(where).length) {
        params.where = where;
      }

      storeList(params).then(function (res) {
        var data = res && res.data ? res.data : res;
        _this.tableData = data && data.rows || [];
        _this.total = data && data.count || 0;
        _this.loading = false;
      }).catch(function () {
        _this.tableData = [];
        _this.total = 0;
        _this.loading = false;
      });
    },
    // 搜索
    onSearch: function onSearch() {
      this.currentPage = 1;
      this.loadData();
    },
    onReset: function onReset() {
      this.searchNumber = '';
      this.searchLicenseName = '';
      this.searchShopNo = '';
      this.searchStatus = '';
      this.currentPage = 1;
      this.loadData();
    },
    onSizeChange: function onSizeChange(size) {
      this.pageSize = size;
      this.currentPage = 1;
      this.loadData();
    },
    onPageChange: function onPageChange(page) {
      this.currentPage = page;
      this.loadData();
    },
    // 导出Excel
    onExport: function onExport() {
      var _this2 = this;

      var title = '店铺申请列表';
      this.$refs['excel'].show(title, this.exportModel, function (ret, tag, model) {
        if (!ret) return;
        var columns = model.filter(function (item) {
          return item.show === 1;
        });

        if (columns.length === 0) {
          _this2.$message({
            message: '请至少勾选一个导出字段',
            type: 'warning'
          });

          return;
        }

        _this2.$g.fun.startLoading();

        _this2.getExportData(tag).then(function (data) {
          var rows = data.map(function (r) {
            return _objectSpread({}, r, {
              status: _this2.statusText(r.status)
            });
          });

          _this2.$export.excel({
            columns: columns,
            data: rows,
            title: title
          }).then(function () {
            _this2.$g.fun.endLoading();
          });
        }).catch(function () {
          _this2.$g.fun.endLoading();
        });
      });
    },
    getExportData: function getExportData(isAll) {
      if (isAll === 0) {
        return Promise.resolve(this.tableData);
      }

      var params = {
        page: 1,
        limit: 1000000
      };
      var where = {};

      if (this.searchNumber) {
        where.number = this.searchNumber;
      }

      if (this.searchLicenseName) {
        where.license_name = this.searchLicenseName;
      }

      if (this.searchShopNo) {
        where.shop_no = this.searchShopNo;
      }

      if (this.searchStatus !== '' && this.searchStatus !== null) {
        where.status = this.searchStatus;
      }

      if (Object.keys(where).length) {
        params.where = where;
      }

      return storeList(params).then(function (res) {
        var data = res && res.data ? res.data : res;
        return data && data.rows || [];
      });
    },
    // 状态文本
    statusText: function statusText(status) {
      var map = {
        0: '待审核',
        1: '已通过',
        '-1': '已拒绝'
      };
      return map[status] || '未知';
    },
    statusTagType: function statusTagType(status) {
      var map = {
        0: 'info',
        1: 'success',
        '-1': 'danger'
      };
      return map[status] || 'info';
    },
    // 显示审核弹窗
    showReviewDialog: function showReviewDialog(row) {
      var _this3 = this;

      this.currentRow = row;
      this.reviewForm = {
        status: 1,
        remark: ''
      };
      this.reviewDialogVisible = true;
      this.$nextTick(function () {
        if (_this3.$refs.reviewForm) {
          _this3.$refs.reviewForm.clearValidate();
        }
      });
    },
    // 显示添加弹窗
    showAddDialog: function showAddDialog() {
      var _this4 = this;

      this.editForm = {
        id: '',
        number: '',
        license_name: '',
        license_legal_person: '',
        license_credit_code: '',
        license_company_type: '',
        license_registered_capital: '',
        license_valid_period: '',
        license_business_address: '',
        license_img: ''
      };
      this.editDialogVisible = true;
      this.$nextTick(function () {
        if (_this4.$refs.editForm) {
          _this4.$refs.editForm.clearValidate();
        }
      });
    },
    // 显示编辑弹窗
    showEditDialog: function showEditDialog(row) {
      var _this5 = this;

      this.editForm = {
        id: row.id,
        license_name: row.license_name || '',
        license_legal_person: row.license_legal_person || '',
        license_credit_code: row.license_credit_code || '',
        license_company_type: row.license_company_type || '',
        license_registered_capital: row.license_registered_capital || '',
        license_valid_period: row.license_valid_period || '',
        license_business_address: row.license_business_address || '',
        license_img: row.license_img || ''
      };
      this.editDialogVisible = true;
      this.$nextTick(function () {
        if (_this5.$refs.editForm) {
          _this5.$refs.editForm.clearValidate();
        }
      });
    },
    // 提交编辑
    onEditSubmit: function onEditSubmit() {
      var _this6 = this;

      this.$refs.editForm.validate(function (valid) {
        if (!valid) return;
        _this6.editLoading = true;

        var data = _objectSpread({}, _this6.editForm);

        storeHandle(data).then(function (res) {
          _this6.$message({
            message: _this6.editForm.id ? '编辑成功' : '添加成功',
            type: 'success'
          });

          _this6.editDialogVisible = false;
          _this6.editLoading = false;

          _this6.loadData();
        }).catch(function () {
          _this6.editLoading = false;
        });
      });
    },
    // 删除店铺
    onDelete: function onDelete(row) {
      var _this7 = this;

      this.$confirm("\u786E\u8BA4\u5220\u9664\u5E97\u94FA\u300C".concat(row.license_name || row.shop_no, "\u300D\uFF1F"), '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        storeDelete({
          id: row.id
        }).then(function (res) {
          _this7.$message({
            message: '删除成功',
            type: 'success'
          });

          _this7.loadData();
        });
      }).catch(function () {});
    },
    // 提交审核
    onReviewSubmit: function onReviewSubmit() {
      var _this8 = this;

      this.$refs.reviewForm.validate(function (valid) {
        if (!valid) return;
        _this8.reviewLoading = true;
        var data = {
          id: _this8.currentRow.id,
          status: _this8.reviewForm.status,
          remark: _this8.reviewForm.remark
        }; // TODO: 替换为真实接口

        storeReview(data).then(function (res) {
          var msg = '审核完成';
          if (_this8.reviewForm.status === 1) msg = '审核通过';else if (_this8.reviewForm.status === -1) msg = '已拒绝申请';

          _this8.$message({
            message: msg,
            type: 'success'
          });

          _this8.reviewDialogVisible = false;
          _this8.reviewLoading = false;

          _this8.loadData();
        }).catch(function () {
          _this8.reviewLoading = false;
        });
      });
    },
    // 营业执照上传前校验
    onBeforeLicenseUpload: function onBeforeLicenseUpload(file) {
      var isImage = file.type.startsWith('image/');

      if (!isImage) {
        this.$message.error('只能上传图片文件');
      }

      return isImage;
    },
    // 营业执照上传
    onUploadLicense: function onUploadLicense(option) {
      upload.upload(option, {
        type: 'license'
      });
    },
    // 营业执照上传成功
    onLicenseUploadSuccess: function onLicenseUploadSuccess(response) {
      if (response && response.url) {
        this.$set(this.editForm, 'license_img', response.url);
      }
    },
    // 预览营业执照
    previewLicense: function previewLicense(row) {
      this.licensePreviewUrl = row.license_img;
      this.licenseDialogVisible = true;
    },
    // 显示店铺编号
    showStoreNumber: function showStoreNumber(row) {
      this.currentRow = row;
      this.numberDialogVisible = true;
    },
    // 复制店铺编号
    copyStoreNumber: function copyStoreNumber(number) {
      var aux = document.createElement('input');
      aux.setAttribute('value', number);
      document.body.appendChild(aux);
      aux.select();
      document.execCommand('copy');
      document.body.removeChild(aux);
      this.$message({
        message: '已复制到剪贴板',
        type: 'success'
      });
    }
  }
};